import { useAuth } from '../../hooks/useAuth';

export function DashboardHeader() {
  const { user } = useAuth();
  
  return (
    <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">Tableau de bord</h1>
        <p className="text-slate-500 mt-1">
          Bienvenue, {user?.name}. Voici un aperçu global de votre activité immobilière.
        </p>
      </div>
    </div>
  );
}
